export default {
  path: 'account',
  name: 'Account',
  component: () => import('@/views/private/MyUser.vue'),
  children: [
    {
      path: 'preferenze-notifiche',
      name: 'NotificationPreferences',
      component: () => import('@/components/my-user/NotificationsPreferences.vue'),
    },
    {
      path: 'anagrafica',
      name: 'Anagrafica',
      component: () => import('@/components/my-user/Anagrafica.vue'),
    },
    {
      path: 'password',
      name: 'UpdatePassword',
      component: () => import('@/components/my-user/UpdatePassword.vue'),
    },
  ],
};
